module.exports = __webpack_public_path__ + "img/stickers-tableau-amortissement.121ee99d.jpg";